import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, RowsSkeletonLoader } from '@node-space/ui-components'
import { PaymentStatus } from 'types/payments'
import { FiatPayout, MassPayoutCryptoBatch, PreProcessedPayouts } from '../types'

interface MassPayoutReviewCalloutsProps {
  loadingMassFiatPayoutDetails?: boolean
  cryptoBatchPayout?: MassPayoutCryptoBatch
  massFiatPayoutInformation?: FiatPayout
  massPayoutPreProcessedPayouts?: PreProcessedPayouts[]
  isPendingCryptoMassPayout?: boolean
  isPendingDeleteCryptoRecord?: boolean
  isCrypto?: boolean
  paymentsReadyToBeProcessed?: string
  isPayoutSubmitted?: boolean
  numberOfErrors?: number
}

export const MassPayoutReviewCallouts = ({
  loadingMassFiatPayoutDetails,
  cryptoBatchPayout,
  massFiatPayoutInformation,
  massPayoutPreProcessedPayouts,
  isPendingCryptoMassPayout,
  isPendingDeleteCryptoRecord,
  isCrypto,
  paymentsReadyToBeProcessed,
  isPayoutSubmitted,
  numberOfErrors,
}: MassPayoutReviewCalloutsProps) => {
  const { t } = useTranslation()
  return (
    <>
      <Box className="mb-4">
        {(loadingMassFiatPayoutDetails && !massPayoutPreProcessedPayouts) ||
        isPendingCryptoMassPayout ||
        isPendingDeleteCryptoRecord ? (
          <RowsSkeletonLoader rows={1} />
        ) : (
          !isPayoutSubmitted && <Callout variant="success">{paymentsReadyToBeProcessed}</Callout>
        )}
      </Box>

      <Box className="mb-4">
        {loadingMassFiatPayoutDetails || isPendingCryptoMassPayout ? (
          <RowsSkeletonLoader rows={1} />
        ) : (
          numberOfErrors > 0 && (
            <Callout variant="error">
              {t('massPayouts.errorWarnings', {
                numberOfErrors: numberOfErrors,
                batchName: isCrypto
                  ? cryptoBatchPayout?.fileName
                  : massFiatPayoutInformation?.alias,
              })}
            </Callout>
          )
        )}
      </Box>
      {massFiatPayoutInformation?.status === PaymentStatus.CREATED && (
        <Box className="mb-4">
          {loadingMassFiatPayoutDetails || isPendingCryptoMassPayout ? (
            <RowsSkeletonLoader rows={1} />
          ) : (
            <Callout variant="warning">
              {t(`massPayouts.${isCrypto ? 'cryptoPaymentsValidation' : 'fiatPaymentsValidation'}`)}
            </Callout>
          )}
        </Box>
      )}
    </>
  )
}
